import { render } from "./StaffForm.vue?vue&type=template&id=4db9310f&scoped=true"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=4db9310f&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db9310f"]])

export default __exports__